import { Link } from "react-router-dom";
import { mangaList } from "@/mocks/manga";
import { SectionTitle } from "./SectionTitle";

export default function SerialNew() {
  const items = mangaList.filter((m) => m.category === "serial");

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          eyebrow="NEW SERIAL"
          title="连载新开 · 抢先发现"
          desc="连载新开一站掌握，刚开坑的长篇佳作第一时间找到。"
          to="/serial"
          linkText="查看全部连载"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((m) => (
            <Link
              key={m.id}
              to={`/article/${m.id}`}
              className="group relative overflow-hidden rounded-2xl bg-foreground-950"
            >
              <img
                src={m.cover}
                alt={`${m.title} 连载新开`}
                className="h-72 w-full object-cover object-top transition duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/30 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4">
                <span className="mb-2 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
                  <i className="ri-sparkling-2-fill text-[10px]"></i>
                  新开连载
                </span>
                <h3 className="font-heading text-lg text-background-50">
                  {m.title}
                </h3>
                <p className="mt-1 text-xs text-background-100/80">
                  连载至 {m.chapters} 话 · {m.update}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}